var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M23.333 6c-2.6 0-5.4.533-7.333 2-1.933-1.467-4.733-2-7.333-2-1.934 0-3.987.293-5.707 1.053-.973.44-1.627 1.387-1.627 2.467v15.04c0 1.733 1.627 3.013 3.307 2.587 1.307-.334 2.693-.48 4.027-.48 2.08 0 4.293.346 6.08 1.226.8.4 1.706.4 2.493 0 1.787-.893 4-1.226 6.08-1.226 1.333 0 2.72.146 4.027.48 1.68.44 3.306-.84 3.306-2.587V9.52c0-1.08-.653-2.027-1.626-2.467C27.32 6.293 25.267 6 23.333 6ZM28 22.973c0 .84-.773 1.454-1.6 1.307-1-.187-2.04-.267-3.067-.267-2.266 0-5.533.867-7.333 2V10.667c1.8-1.134 5.067-2 7.333-2 1.227 0 2.44.12 3.6.373.614.133 1.067.68 1.067 1.307v12.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M18.64 14.68a.984.984 0 0 1-.947-.693.991.991 0 0 1 .64-1.254c2.054-.666 4.707-.88 7.147-.6.547.067.947.56.88 1.107-.067.547-.56.947-1.107.88-2.16-.253-4.52-.053-6.306.52-.107.013-.214.04-.307.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M18.64 18.227a.984.984 0 0 1-.947-.694.991.991 0 0 1 .64-1.253c2.04-.667 4.707-.88 7.147-.6.547.067.947.56.88 1.107-.067.546-.56.946-1.107.88-2.16-.254-4.52-.054-6.306.52-.107.026-.214.04-.307.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M18.64 21.773a.984.984 0 0 1-.947-.693.991.991 0 0 1 .64-1.253c2.04-.667 4.707-.88 7.147-.6.547.066.947.56.88 1.106-.067.547-.56.934-1.107.88-2.16-.253-4.52-.053-6.306.52-.107.027-.214.04-.307.04Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 15.993,
    x2: 15.993,
    y1: 6,
    y2: 28.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 22.005,
    x2: 22.005,
    y1: 12.013,
    y2: 14.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 22.005,
    x2: 22.005,
    y1: 15.56,
    y2: 18.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720ECF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 22.005,
    x2: 22.005,
    y1: 19.107,
    y2: 21.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720ECF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.76a9524ebb000ba4842126fee76ce932.svg";
export { ForwardRef as ReactComponent };